import React from 'react'
import { Paper, Grid, Text, Group, Button, Divider } from '@mantine/core'
import { IconTrash, IconEdit, IconInfoCircle } from '@tabler/icons-react'

const CardHscode = ({ data, onEdit, onDelete }) => {
    const getTaxValue = (label) => {
        const tax = data.taxes?.find(t => t.label.toLowerCase() === label.toLowerCase())
        return tax ? `${tax.value} %` : '-'
    }

    return (
        <Paper withBorder p="md" radius="md" mb="md">
            <Group justify="space-between" mb="xs">
                <Text fw={700} c="red">ID {data.id}</Text>
            </Group>

            <Grid gutter="xl">
                <Grid.Col span={4}>
                    <Text c="dimmed" size="xs">Description</Text>
                    <Text fw={500} mb="sm">{data.description || '-'}</Text>

                    <Text c="dimmed" size="xs">Native Description</Text>
                    <Text fw={500}>{data.native_description || '-'}</Text>
                </Grid.Col>

                <Grid.Col span={4}>
                    <Text c="dimmed" size="xs">Native Language</Text>
                    <Text fw={500} mb="sm">{data.native_language || '-'}</Text>

                    <Text c="dimmed" size="xs">Hs Code</Text>
                    <Text fw={500}>{data.code || '-'}</Text>
                </Grid.Col>

                <Grid.Col span={4}>
                    <Grid>
                        <Grid.Col span={6}>
                            <Text c="dimmed" size="xs">BM:</Text>
                            <Text fw={500}>{getTaxValue('bm')}</Text>
                        </Grid.Col>
                        <Grid.Col span={6}>
                            <Text c="dimmed" size="xs">PPN:</Text>
                            <Text fw={500}>{getTaxValue('ppn')}</Text>
                        </Grid.Col>
                        <Grid.Col span={6} mt="xs">
                            <Text c="dimmed" size="xs">PPH:</Text>
                            <Text fw={500}>{getTaxValue('pph')}</Text>
                        </Grid.Col>
                        <Grid.Col span={6} mt="xs">
                            <Text c="dimmed" size="xs">Total Tax:</Text>
                            <Text fw={700} c="red" size="lg">{data.total_tax} %</Text>
                        </Grid.Col>
                    </Grid>
                </Grid.Col>
            </Grid>

            <Divider my="md" />

            <Group justify="space-between">
                <Button variant="default" leftSection={<IconInfoCircle size={16} />} size="xs">
                    Detail Category Rules
                </Button>
                <Group gap="xs">
                    <Button
                        variant="default"
                        leftSection={<IconTrash size={16} />}
                        color="red"
                        size="xs"
                        onClick={() => onDelete(data)}
                    >
                        Delete
                    </Button>
                    <Button
                        variant="filled"
                        leftSection={<IconEdit size={16} />}
                        color="red"
                        size="xs"
                        onClick={() => onEdit(data)}
                    >
                        Edit
                    </Button>
                </Group>
            </Group>
        </Paper>
    )
}

export default CardHscode
